<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import BaseForm from './base-form';

export default {

    data: function() {
        return {
            ...BaseForm.data(),
            selected_communities: '',
            persistents: {
                selected_communities: [],
            }
        }
    },

    props: [
        'openModal',
        'closeModal',
        'isModalOpen',
        'communityId',
    ],

    mounted() {
        if (this.communityId) {
            this.persistents.selected_communities = [this.communityId];
        }

        this.boot();
    },

    computed: {
        ...BaseForm.computed,
        ...mapGetters({
            modalData: 'modal/getData'
        })
    },

    watch: {
        ...BaseForm.watchers,
        'selected_communities': function(val, oldVal) {
            if (oldVal) {
                // Remove the old value from the selected communities
                this.persistents.selected_communities = this.persistents.selected_communities.filter(id => id != oldVal);
            }

            if (val) {
                this.persistents.selected_communities = [val, ...this.persistents.selected_communities];
            }
        }
    },

    created() {
        if (this.modalData.communityId) {
            this.persistents['selected_communities'] = [this.modalData.communityId];
        }
    },

    methods: {
        ...BaseForm.methods,

        submit(event) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.beforeSubmit().then((token) => {
                        this.form.post(event.target.action, {
                                ...this.fields, ...this.persistents,
                                'g-recaptcha-response': token
                            })
                            .then((result) => this.success(result, event))
                            .catch(() => this.failure());
                    });
                }
            });
        }
    }
};

</script>



// WEBPACK FOOTER //
// resources/components/forms/digital-registration-form.vue